import * as React from "react";
import styled, { css } from "styled-components";
import { StatCard } from "components/common";
import useHistory from "routing/useHistory";
import DataTieringRoutes from "../Routes";
const CREDENTIAL_PROBLEMS_FILTER_URL = `${DataTieringRoutes.WARM_TIER_REPOSITORIES}?filters=credential_status%3Dmissing&filters=credential_status%3Dinvalid`;
const StatsRow = styled.div(
  ({ theme }) => css`
    display: flex;
    margin-bottom: ${theme.spacings.lg};
    gap: ${theme.spacings.md};
    flex-wrap: wrap;
  `
);
const WarmTierCounters = ({
  searchRoleNodeCount,
  availableBackendsCount,
  configuredCount,
  credentialProblemsCount
}) => {
  const history = useHistory();
  return /* @__PURE__ */ React.createElement(StatsRow, null, /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: searchRoleNodeCount,
      label: "Nodes with Search Role",
      helpText: 'At least one node must have the "search" role. A single node should not be granted both the "search" and "data" roles.'
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: availableBackendsCount,
      label: "Available Plugins",
      helpText: "The count of backend plugins installed to all search nodes and ready to use."
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: configuredCount,
      label: "Configured Repositories",
      helpText: "The count of searchable snapshot repositories that are fully configured and ready to assign to Indices or Archiving Strategies."
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: credentialProblemsCount,
      label: "Credential Problems",
      helpText: "Repositories with missing or invalid credentials. Snapshot Archiving requires working credentials for every repository it may read. Click to filter the list.",
      variant: "warning",
      onClick: () => history.push(CREDENTIAL_PROBLEMS_FILTER_URL)
    }
  ));
};
export default WarmTierCounters;
